export * from "./types";
import * as queries from "./queries";

const ThreeSpeakIntegration = {
  queries,
};

export { ThreeSpeakIntegration };
